<template v-slot="main">
  <div class="modal-container">
    <div class="modal-header">
      <h2>{{ $t('zencall.title') }}</h2>
      <h3>{{ $t('zencall.immediate_or_schedule_callback') }}</h3>
    </div>

    <div class="modal-body">
      <p>{{ $t('zencall.select_a_skill_for_callback') }}</p>
      <p class="errMsg" v-if="hasErr === true">
        {{ $t('zencall.please_choose_a_skill') }}
      </p>
      <select v-model="zencallSkill">
        <option v-for="skill in skills"
                v-bind:key="skill.value"
                v-bind:value="skill.value">
          {{ $t(skill.text) }}
        </option>
      </select>
    </div>

    <div class="modal-footer">
      <button v-on:click="closeModal" class="btn btn-inline btn-inverse">
        {{ $t('Cancel') }}
      </button>
      <button v-on:click="zencall" class="btn btn-inline">{{ $t('OK') }}</button>
    </div>
  </div>
</template>

<script>
import BaseModal from '@/layout/modals/BaseModal.vue'

export default {
  extends: BaseModal,
  name: 'ZencallModal',
  data () {
    return {
      hasErr: false,
      skills: [],
      zencallSkill: ''
    }
  },
  methods: {
    zencall () {
      if (this.zencallSkill !== '') {
        this.$store.dispatch('rooms/sendLaunchZenCall',
          this.zencallSkill)
        this.closeModal()
      } else {
        this.hasErr = true
      }
    }
  },
  created () {
    const skills = [{
      value: '',
      text: 'zencall.thanks_for_choosing_a_skill'
    }]
    this.$store.getters['rooms/getZencallSkills'].forEach((skill) => {
      skills.push({
        value: skill.uuid,
        text: skill.label
      })
    })
    this.skills = skills
  }
}
</script>
